export const AbhaSession = {
  // Save ABHA login state
  setAbhaLoggedIn(state) {
    localStorage.setItem('abhaLoggedIn', JSON.stringify(state));
  },

  // Get ABHA login state
  getAbhaLoggedIn() {
    const state = localStorage.getItem('abhaLoggedIn');
    return state ? JSON.parse(state) : null;
  },

  // Clear ABHA login state (only on explicit logout)
  clearAbhaLoggedIn() {
    localStorage.removeItem('abhaLoggedIn');
  },

  // Check if user is logged in via ABHA
  isAbhaLoggedIn() {
    const state = this.getAbhaLoggedIn();
    return state && state.isLoggedIn === true;
  },

  // Get ABHA user data
  getAbhaUserData() {
    const state = this.getAbhaLoggedIn();
    return state ? state.userData : null;
  },

  // Check if session is still valid (optional)
  isSessionValid() {
    const state = this.getAbhaLoggedIn();
    if (!state || !state.loginTime) return false;

    const loginTime = new Date(state.loginTime);
    const now = new Date();
    const hoursDiff = (now - loginTime) / (1000 * 60 * 60);

    // Session valid for 24 hours (adjust as needed)
    return hoursDiff < 24;
  },

  // Get valid session
  getValidSession() {
    return this.isSessionValid() ? this.getAbhaLoggedIn() : null;
  }
};